// §78 Client workspaces: what an invited client can open.
export const RADAR_MODULES = [["companies", "Companies", ""], ["people", "Decision Makers", "people"], ["signals", "Signals feed", "signals"], ["imports", "Imports", "imports"], ["heatmap", "Heatmap", "heatmap"]];
// Opportunity Radar add-ons (§101): own-data MPC Marketplace, LinkedIn Follow-Ups and Market Intelligence.
export const RADAR_EXTRAS = [["mpc", "MPC Marketplace"], ["linkedin", "LinkedIn Follow-Ups"], ["intel", "Market Intelligence"]];
export const DEFAULT_MODULES = { radar: RADAR_MODULES.map(([k]) => k), workflows: true, si: false, mpc: true, linkedin: true, intel: true };

export const clientMods = (c) => ({ ...DEFAULT_MODULES, ...(c?.modules || {}) });
export const hasRadar = (c) => clientMods(c).radar.length > 0;
export const hasExtra = (c, k) => hasRadar(c) && clientMods(c)[k] !== false;
export const hasRCC = (c) => hasRadar(c) || clientMods(c).workflows !== false;
export const isClientAdmin = (c) => c?.role === "admin";
export const canSeeBilling = (c) => !!c?.billing_contact || isClientAdmin(c);
export const clientHome = (c) => {
  const si = clientMods(c).si;
  if (si && hasRCC(c)) return "/client/home";
  return si ? "/admin/si" : hasRadar(c) ? "/admin/rcc/radar" : "/admin/rcc/workflows";
};
export const clientAllowed = (c, path) => {
  const m = clientMods(c);
  if (path === "/client/home") return m.si && hasRCC(c);
  if (path.startsWith("/client/outreach")) return true;
  if (path === "/client/billing") return canSeeBilling(c);
  if (path.startsWith("/admin/si")) return m.si;
  if (path.startsWith("/admin/rcc/workflows")) return m.workflows !== false;
  const ex = RADAR_EXTRAS.find(([k]) => path.startsWith(`/admin/rcc/${k}`) || path.startsWith(`/admin/rcc/radar/${k}`));
  if (ex) return hasExtra(c, ex[0]);
  if (path.startsWith("/admin/rcc/radar/campaigns") || path.startsWith("/admin/rcc/radar/connections")) return hasRadar(c);
  if (path.startsWith("/admin/rcc/radar")) {
    if (/\/radar\/(companies|people)\/[^/]+/.test(path)) return hasRadar(c);
    const tab = path.split("/")[4] || "";
    const mod = RADAR_MODULES.find(([, , t]) => t === tab);
    return !!mod && m.radar.includes(mod[0]);
  }
  return false;
};
// Remember where to land after Google sign-in from the client login page.
export const CLIENT_RETURN = "/client";
